import { default as game51wcOw1aeNMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/game.vue?macro=true";
import { default as indexqVa6MAhWUkMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/index.vue?macro=true";
import { default as info0EtD79VK8aMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/info.vue?macro=true";
import { default as no_45rewardVXlMQqBN1WMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/no-reward.vue?macro=true";
import { default as prizeVYLIecELFYMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/prize.vue?macro=true";
import { default as rewardHBTLLz86YsMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/reward.vue?macro=true";
import { default as scannerj4yj8YBfKpMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/scanner.vue?macro=true";
import { default as _91challengeId_93c4sKfkUizWMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/static/promoter/[contentVersionId]/[challengeId].vue?macro=true";
import { default as registrationyX8pG5pJvcMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/static/registration.vue?macro=true";
import { default as _91batchId_93HchHQA630aMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/static/results/[batchId].vue?macro=true";
import { default as statsWuGJQkDNkHMeta } from "/home/runner/work/wdd/wdd/frontend/ubs/pages/stats.vue?macro=true";
export default [
  {
    name: "game",
    path: "/game",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/game.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/info.vue").then(m => m.default || m)
  },
  {
    name: "no-reward",
    path: "/no-reward",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/no-reward.vue").then(m => m.default || m)
  },
  {
    name: "prize",
    path: "/prize",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/prize.vue").then(m => m.default || m)
  },
  {
    name: "reward",
    path: "/reward",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/reward.vue").then(m => m.default || m)
  },
  {
    name: "scanner",
    path: "/scanner",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/scanner.vue").then(m => m.default || m)
  },
  {
    name: "static-promoter-contentVersionId-challengeId",
    path: "/static/promoter/:contentVersionId()/:challengeId()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/static/promoter/[contentVersionId]/[challengeId].vue").then(m => m.default || m)
  },
  {
    name: "static-registration",
    path: "/static/registration",
    meta: registrationyX8pG5pJvcMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/static/registration.vue").then(m => m.default || m)
  },
  {
    name: "static-results-batchId",
    path: "/static/results/:batchId()",
    meta: _91batchId_93HchHQA630aMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/static/results/[batchId].vue").then(m => m.default || m)
  },
  {
    name: "stats",
    path: "/stats",
    component: () => import("/home/runner/work/wdd/wdd/frontend/ubs/pages/stats.vue").then(m => m.default || m)
  }
]